// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationControl_container__YFY2d","arrowLeft":"NavigationControl_arrowLeft__hDOcv","button":"NavigationControl_button__d5G2t"};